import { useState } from "react";
import { withRouter } from "react-router-dom";
import '../assets/css/partnerProgram.scss';


function SignUpBlock(props) {


    const [title] = useState(props.title);
    const [subTitle] = useState(props.subTitle);
    const [buttonLink] = useState(props.bannerLink);
    const [buttonName] = useState(props.buttonName);
    const [target] = useState(props.target);



    return (

        <div className="getReadySectionLayout mb-5">
            <div className="getReadySectionTitles">
                <div className="getReadySectionHeader mb-4">
                    <div className="getReadySectionHeaderContent fontSize40"> {title}</div>
                </div>
                <div className="getReadySectionCopy mt-4">
                    <div className="getReadySectionCopyContent">{subTitle}</div>
                </div>
                <div className="buttonDiv">
                    <a href={buttonLink} target={target ? target :"_blank"} className="wid65 d-flex justify-content-center"  >
                        <div className="buttonWithoutBorder buttonSignUp pad5-4">
                            <div className="buttonLetters">{buttonName}</div>
                        </div>
                    </a>
                </div>
            </div>
        </div>

    )


}

export default withRouter(SignUpBlock);



